import Expiration from "./Expiration";

export default Expiration;
